function Header({ caption, bgImg }) {
  const backgroundCaption = {
    backgroundImage: `url(${bgImg})`,
  };
  return (
    <header className="header" style={backgroundCaption}>
      <div className="header__text-box">
        <h1 className="heading-primary">
          <span className="heading-primary--main">{caption}</span>
        </h1>
      </div>
    </header>
  );
}

export default Header;
